import { CodeNameModel } from 'components/common/types';
import BaseSelect from 'lib/BaseSelect';
import { findOption } from 'lib/BaseSelect/utils';

type ActionRendererProps = {
  data: {
    type: string;
  };
  onTypeChange: (props: unknown) => void;
};

const ActionRenderer: React.FC<ActionRendererProps> = ({ data, onTypeChange }) => {
  const dropdownOptions = [
    {
      code: 'inclusion',
      name: 'Include',
    },
    {
      code: 'exclusion',
      name: 'Exclude',
    },
  ];

  const onDropdownSelect = (_dropdownName: string, selectedObj: CodeNameModel): void => {
    onTypeChange({ ...data, type: selectedObj?.code ?? '' });
  };

  return (
    <div className="w-[130px] p-1">
      <BaseSelect
        name="type"
        options={dropdownOptions}
        selectedValue={findOption(dropdownOptions, 'code', data.type)}
        onSelect={onDropdownSelect}
        placeholder="Set rule"
      />
    </div>
  );
};

export default ActionRenderer;
